import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getSubscriptionProducts } from '../api/subscription.api';
import { getDataFromResponse } from '../../../core/constant/utils/react-query-utils/getDataFromResponse';
import { ErrorSource } from '../../../core/constant/model/api/api';
import { handleApiError } from '../../../core/constant/utils/error.helper';
import { setApiError } from '../../../core/store/slices/apiError.slice';
import { setSubscriptions } from '../../../core/store/slices/subscription.slice';
import { subscriptionKeys } from '../utils/subscriptionKeys';

export const useSubscriptionsQuery = ({ params }: { params: string; }) => {
  const dispatch = useDispatch();

  return useQuery(
    subscriptionKeys.lists(),
    async () => {
      const response = await getSubscriptionProducts({params});
      const data = getDataFromResponse(response);
   
      if (data.statusCode && data.statusCode !== 200) {
        const error = new Error(data.message || 'Request failed') as any;
        error.response = {
          data: data,
          status: data.statusCode,
        };
        throw error;
      }
      return data;
    },
    {
      onSuccess: (data) => {
        dispatch(setSubscriptions(data.data));
      },
      onError: (error) => {
        const errorDetails = handleApiError(error);
        dispatch(
          setApiError({
            source: ErrorSource.SUBSCRIPTIONS_LIST,
            error: {
              message: errorDetails.message || 'Failed to fetch subscription products',
              statusCode: errorDetails.status || 500,
              stack: errorDetails.stack || '',
            },
          })
        );
      },
      staleTime: 0, // 5 minutes
      cacheTime: 0, // 10 minutes,
    },
  );
};
